import { render, staticRenderFns } from "./AvatarList.vue?vue&type=template&id=fda0b38c&scoped=true"
import script from "./AvatarList.vue?vue&type=script&lang=js"
export * from "./AvatarList.vue?vue&type=script&lang=js"
import style0 from "./AvatarList.vue?vue&type=style&index=0&id=fda0b38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda0b38c",
  null
  
)

export default component.exports